import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {CountrySelection, DropdownInput} from './CountryPicker.style';
import {isNullOrEmpty} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {DropdownMultipleValueProps, DropdownOptionProps} from '../../models/DropdownProps';
import {
    DROPDOWN_OPTION,
    getDropdownOptionProps,
    getEmptyDropdownOptionProps,
    SELECT_COUNTRY,
    SELECT_PREFIX
} from '../../utils/DropdownOptionPropsUtils';

export const CountryPicker: React.VFC<DropdownMultipleValueProps<string>> = (props) => {
    const getOptions = (countrySelectionState: string[]): DropdownOptionProps[] => {
        let options: DropdownOptionProps[] = [];
        let localeItem: DropdownOptionProps = getEmptyDropdownOptionProps(SELECT_COUNTRY, SELECT_COUNTRY, DROPDOWN_OPTION);
        options.push(localeItem);
        props.dataSource.filter(country => (isNullOrEmpty(country.value)
            || (!countrySelectionState.includes(country.value))))
            .map(country => {
                localeItem = {
                    name: SELECT_PREFIX.concat(country.name),
                    value: country.value
                } as DropdownOptionProps;
                options.push(localeItem);
            });

        return getDropdownOptionProps(options, SELECT_COUNTRY, DROPDOWN_OPTION);
    };

    const [countrySelection, setCountrySelection] = useState<string[]>([]);
    const [countryInput, setCountryInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [countryOptions, setCountryOptions] = useState<DropdownOptionProps[]>(getOptions([]));

    const setState = (selectionState: string[], selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        setCountrySelection(selectionState);
        props.onChange(selectionState);
        setCountryOptions(selectionOptions);
        if (resetInput) {
            setCountryInput('');
        }
    };

    useEffect(() => {
        setCountryOptions(getOptions([]));
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState([], getOptions([]), true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setCountryInput(eventValue);
        let selectionOptions = countryOptions;
        let selectionState = [eventValue];
        if (props.resetInput) {
            selectionOptions = countryOptions.filter(country => (country.value !== eventValue));
            selectionState = [...countrySelection];
            if (!countrySelection.includes(eventValue)) {
                selectionState = selectionState.concat(eventValue);
            }
        }
        setState(selectionState, selectionOptions, props.resetInput);
    };

    const handleDelete = (countryKey: string) => {
        let selectionState = countrySelection.filter(country => (country !== countryKey));
        setState(selectionState, getOptions(selectionState), true);
    };

    const getLabel = (country: string): string => {
        let label = '';
        if (country) {
            label = country;
        }

        return label;
    };

    return (
        <Accordion localizedHeadline={t('COUNTRY_PICKER_CAPTION')}>
            <DropdownInput id={generateIdentifier('countryId_'.concat(countryInput))}
                           defaultValue={props.defaultValue ? props.defaultValue : ''}
                           value={countryInput}
                           options={countryOptions}
                           disabled={props.disabled}
                           onChange={handleInput}/>
            {countrySelection?.map(country => {
                return props.resetInput &&
                    <CountrySelection id={generateIdentifier(country)}
                                      key={country}
                                      label={getLabel(country)}
                                      buttonClose
                                      onClose={() => handleDelete(country)}/>;
            })}
        </Accordion>
    );
};
